module.exports = __webpack_public_path__ + "media/images/dividend/ic-gift-open-faae9066b6f7e6c3b7f179bc4953d271.svg";